<template>
  <div
    class="dropdown is-right"
    :class="{ 'is-active': isActive }"
    v-click-outside="close"
  >
    <div class="dropdown-trigger">
      <span
        v-tippy="{ placement: 'left' }"
        :title="tooltip"
      >
        <button
          class="button has-text-info"
          :disabled="disabled || loading"
          @click.prevent="toggle"
        >
          <span class="icon">
            <i class="fal fa-file-csv" />
          </span>
          <span class="icon is-small">
            <i class="fal fa-angle-down" />
          </span>
        </button>
      </span>
    </div>
    <div class="dropdown-menu" role="menu">
      <div class="dropdown-content">
        <a
          v-for="(option, index) in options"
          :key="index"
          class="dropdown-item"
          @click.prevent="download(option)"
        >
          <span class="icon is-small has-text-info">
            <i class="fal fa-download" />
          </span>
          <span>{{ option.label }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import * as CSVService from '../services/csv.service'
export default {
  name: 'DownloadCSVDropdown',
  props: {
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: String,
      default: 'Download activity'
    }
  },
  data: () => ({
    isActive: false,
    loading: false
  }),
  methods: {
    toggle() {
      if (!this.disabled && !this.loading) {
        this.isActive = !this.isActive
      }
    },
    close() {
      this.isActive = false
    },
    async download(option) {
      this.isActive = false
      this.loading = true

      try {
        const entries = await option.getEntries()
        await CSVService.downloadCSV(option.columns, entries, null, option.filename)
      } catch {
        this.$notify('Something went wrong while downloading the CSV')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.dropdown-menu
  min-width: 14em
.dropdown-item
  display: flex
  align-items: center
  gap: 0.5em
  &:hover
    background: $primary
    color: white
    .has-text-info
      color: white !important
</style>
